export const getUiSocialButtonTemplate = (options = {}) => {
  const {
    type = null,
    size = 'small',
    sizeMode = null,
    stretch = false,
    stretchMode = null,
    iconMode = null,
    classes = null,
    href = null,
    attrs = null,
    title = null
  } = options

  return `
    <a
      class="
        ui-social-button
        ui-social-button--${type}
        ui-social-button--${size}
        ${sizeMode ? `ui-social-button--${sizeMode}` : ''}
        ${stretch ? 'ui-social-button--stretch' : ''}
        ${stretchMode ? `ui-social-button--stretch-${stretchMode}` : ''}
        ${iconMode ? `ui-social-button--${iconMode}` : ''}
        ${classes}
      "
      ${href ? `href="${href}"` : ''}
      target="_blank"
      ${attrs ?? ''}
    >
      <svg
        width="24"
        height="24"
        aria-hidden="true"
        class="ui-social-button__icon"
      >
        <use xlink:href="#ui-${type}-filled"></use>
      </svg>

      <span class="ui-social-button__text f f--m">
        ${title}
      </span>
    </a>
  `
}
